module.exports = __webpack_public_path__ + "/login_ui/img/ua-f3df95ac832382631538d01774176073.svg";